import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface Theme {
  name: string;
  properties: any;
}


@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  title = environment.title;
  customerLogo = `url("./assets/data/${this.title}/logo/logo.svg")`;

  themeDefault = [{
    name: "Light", properties: {
      "--brandColor": "#cc0000",
      "--textColor": "white",
      "--bgColor1": "white",
      "--bgColor2": "#e8e8e8",
      "--bodyBGColor": "#e8e8e8",
      "--bodyColor": "rgb(44,44,44)",
      "--cardBGColor": "#fff",
      "--cardColor": "rgb(44,44,44)",
      "--matCardBGColor": "#fff",
      "--matCardColor": "rgba(0,0,0,.87)",
      "--matTabGrpBGColor": "#cc0000",
      "--matMenuPanelBGColor": "white",
      "--matMenuItemActive": "rgb(44,44,44)",
      "--matMenuItemInactive": "#a0a0a0",
      "--cardTextColor": "rgb(44,44,44)",
      "--newCardBgColor": "white",
      "--formTextColor": "rgb(66,66,66)",
      "--formBgColor": "#d6d6d6",
      "--focusformBgColor": "#c4c4c4",
      "--formDisableColor": "rgb(214,214,214,0.5)",
      "--formDisableTextColor": "rgb(66,66,66,0.5)",
      "--brandColorMain": "#cc0000",
      "--basicTextColor": "rgb(44,44,44)",
      "--basicBgColor": "white",
      "--selectedColorTabs": "#f3e6e6",
      "--selectedNavColorTabs": "#941919",
      "--underLineTabsColor": "#cc0000",
      "--breadBgColor": "white",
      "--lineColorChart": "#c4c4c4",
      "--filledColor": "#df838b",
      "--oppositeTextColor": "white",
      "--chartTextColor1": "rgb(44,44,44)",
      "--hoverLegend": "#818181",
      "--anchorHover": "#d8d8d8",
      "--deleteColor": "#ff5162 ",
      "--disabledTextColor": "rgba(0,0,0,0.5)",
      "--greenColor": "#00a11d",
      "--redColor": "#ff4759",
      "--blueColor": "#0068ff",
      "--hoverColor": "#fff",
      "--navColor": "white",
      "--verticalLine": "#d6d6d6",
      "--tcsLogo": 'url("./assets/icons/cleverEnergyLogo.svg")',
      "--customerLogo": this.customerLogo,
      "--signOut": 'url("./assets/icons/logout1.svg")',
      "--secondary4": "#FFFFFF",
      "--support1": "#1CBC9C",
      "--support2": "#3C769B",
      "--support3": "#E84A18",
      "--support4": "#F9A824",
      "--support5": "#af53f5",
      "--support6": "#32a852",
      "--gradientRed": "#EA2B22",                ////////////////////Gradient Graph Colors
      "--gradientYellow": "#FCB61A",
      "--gradientGreen": "#2EDB61",
      "--gradientGreen1": "#48A93F",
      "--gradientActual": "#444a58",
      "--gradientTarget": "#d80024",
      "--gradientBenchMark": "#FFFFFF"
    }
  },
  {
    name: "Blue", properties: {
      "--brandColor": "#1F36C7",
      "--textColor": "white",
      "--textColor1": "#313B43",
      "--textColor2": "#707070",
      "--textColor3": "#535353",
      "--bgColor1": "white",
      "--bgColor2": "#e8e8e8",
      "--bgColor3": "#F2F1F1",
      "--bgColor4" :"#E4EDF5",
      "--bodyBGColor": "#F3F4F6",
      "--bodyColor": "#313B43",
      "--cardBGColor": "#fff",
      "--cardBGColor1": "#dcdcdc",
      "--cardColor": "#313B43",
      "--matCardBGColor": "#fff",
      "--matCardColor": "rgba(0,0,0,.87)",
      "--matTabGrpBGColor": "#cc0000",
      "--matMenuPanelBGColor": "white",
      "--matMenuItemActive": "rgb(44,44,44)",
      "--matMenuItemInactive": "#a0a0a0",
      "--cardTextColor": "rgb(44,44,44)",
      "--cardTextColor1": "#1C1E23",
      "--newCardBgColor": "white",
      "--formTextColor": "#313B43",
      "--formBgColor": "#1F36C7",
      "--focusformBgColor": "#FFFFFF",
      "--formDisableColor": "rgb(214,214,214,0.5)",
      "--formDisableTextColor": "rgb(66,66,66,0.5)",
      "--formLabelText": "#313B43",
      "--formInputBorderColor": "#C4D0DC",
      "--brandColorMain": "#1F36C7",
      "--basicTextColor": "#313B43",
      "--basicBgColor": "white",
      "--selectedColorTabs": "#d9d9ff",
      "--selectedNavColorTabs": "#162790",
      "--underLineTabsColor": "#3f51b5",
      "--breadBgColor": "white",
      "--lineColorChart": "#c4c4c4",
      "--filledColor": "#df838b",
      "--oppositeTextColor": "white",
      "--chartTextColor1": "rgb(44,44,44)",
      "--hoverLegend": "#818181",
      "--anchorHover": "#d8d8d8",
      "--deleteColor": "#ff5162 ",
      "--disabledTextColor": "rgba(0,0,0,0.5)",
      "--greenColor": "#00a11d",
      "--redColor": "#ff4759",
      "--blueColor": "#0068ff",
      "--hoverColor": "#fff",
      "--navColor": "white",
      "--verticalLine": "#c4d0dc",
      "--tcsLogo": 'url("./assets/icons/cleverEnergyLogo.svg")',
      "--customerLogo": this.customerLogo,
      "--signOut": 'url("./assets/icons/logout1.svg")',
      "--downArrow": 'url("./assets/icons/darrow.svg")',
      "--secondary4": "#FFFFFF",
      "--support1": "#EA2B22",
      "--support2": "#ff8000",
      "--support3": "#b55d04",
      "--support4": "#ffff00",
      "--support5": "#9ce6ae",
      "--support6": "#5f8a87",
      "--support7": "#00ffff",
      "--support8": "#0080ff",
      "--support9": "#0000ff",
      "--support10": "#8000ff",
      "--support11": "#ff00ff",
      "--support12": "#ff0080",
      "--support13": "#598dfa",
      "--support14": "#b3f2ff",
      "--support15": "#755faa",
      "--support16": "#cfe8a3",
      "--support17": "#154a54",
      "--support18": "#525e54",
      "--support19": "#fe6f47",
      "--support20": "#ffc0cb",
      "--support21": "#002F5D",
      "--support22": "#38812F",
      "--support23": "#005F60",
      "--support24": "#2A265F",
      "--support25": "#C58C00",
      "--support26": "#8F4700",
      "--support27": "#7D1007",
      "--support28": "#6A6E73",
      "--support29": "#8BC1F7",
      "--support30": "#BDE2B9",
      "--support31": "#A2D9D9",
      "--gradientRed": "#EA2B22",                ////////////////////Gradient Graph Colors
      "--gradientYellow": "#FCB61A",
      "--gradientGreen": "#2EDB61",
      "--gradientGreen1": "#48A93F",
      "--gradientActual": "#444a58",
      "--gradientTarget": "#d80024",
      "--gradientBenchMark": "#FFFFFF",
      "--navOverlay": "#F0F1F3",
      "--dateColor": "#323C58",
      "--quickRange": "#323C58",
      "--placeHolderColor": "#929292",
      "--progressBarBg": "#EDEFF3",
      "--formInputSelectDisable": "#e9ecef",
      "--stateColor1": "#1CBB9B",
      "--stateColor2": "#F4A524",
      "--stateColor3": "#EA2B22",
      "--badgeBgColor": "#cc0000",
      "--lightgreycolor": "#ddd",
      "--bordercolor": "#ecf0f4",
      "--highlighterbg1": "#d2ef81",
      "--highlighterbg2": "#f6a19e",
    }
  },
  {
    name: "Dark", properties: {
      "--brandColor": "#f0eff4",
      "--textColor": "rgb(44,44,44)",
      "--bgColor1": "rgb(44,44,44)",
      "--bgColor2": "rgb(66,66,66)",
      "--bodyBGColor": "rgb(66,66,66)",
      "--bodyColor": "white",
      "--cardBGColor": "rgb(44,44,44)",
      "--cardColor": "white",
      "--matCardBGColor": "rgb(44,44,44)",
      "--matCardColor": "white",
      "--matTabGrpBGColor": "#FFC12E",
      "--matMenuPanelBGColor": "rgb(44,44,44)",
      "--matMenuItemActive": "white",
      "--matMenuItemInactive": "gray",
      "--cardTextColor": "white",
      "--newCardBgColor": "rgb(44,44,44)",
      "--formTextColor": "white",
      "--formBgColor": "rgb(66,66,66)",
      "--focusformBgColor": "grey",
      "--formDisableColor": "rgb(66,66,66,0.5)",
      "--formDisableTextColor": "rgba(243,244,246,0.5)",
      "--brandColorMain": "#FFC12E",
      "--basicTextColor": "white",
      "--basicBgColor": "rgb(44,44,44)",
      "--selectedColorTabs": "#d9d9ff",
      "--breadBgColor": "rgb(44,44,44)",
      "--lineColorChart": "#7b7b7b",
      "--filledColor": "#a97700",
      "--chartTextColor1": "white",
      "--hoverLegend": "#818181",
      "--oppositeTextColor": "rgb(44,44,44)",
      "--anchorHover": "#5c5c5c",
      "--deleteColor": "#ff5162 ",
      "--disabledTextColor": "rgba(255,255,255,0.5)",
      "--greenColor": "#80f295",
      "--redColor": "#ff6c7a",
      "--blueColor": "#93baf3",
      "--hoverColor": "rgb(66, 66, 66)",
      "--navColor": "rgb(44,44,44)",
      "--tcsLogo": 'url("./assets/icons/cleverEnergyLogo.svg")',
      "--customerLogo": this.customerLogo,
      "--signOut": 'url("./assets/icons/logout1.svg")',
    }
  }]
  themeArray;
  active;



  constructor() {
    this.themeArray = this.themeDefault
    // console.log("fffffffff", this.title)
    // console.log("ffffffffddddddddddddf", this.customerLogo)

  }



  setLightTheme(): void {
    this.setActiveTheme(this.themeArray[0]);
  }

  setBlueTheme(): void {
    this.setActiveTheme(this.themeArray[1]);
  }

  setDarkTheme(): void {
    this.setActiveTheme(this.themeArray[2]);
  }

  setTheme(themeName): void {
    let reqTheme = this.themeArray.filter((data) => data.name == themeName)
    if (reqTheme && reqTheme.length) {
      this.setActiveTheme(reqTheme[0]);
    }
    else {
      this.setActiveTheme(this.themeArray[1]);
    }
  }

  setActiveTheme(theme): void {
    this.active = theme;
    Object.keys(this.active.properties).forEach(property => {
      document.documentElement.style.setProperty(property, this.active.properties[property]);
    });
  }

}
